import { ChangeDetectionStrategy, Component, TemplateRef, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { PortfolioBuildingsRoadmapBuildingDTO, PortfolioBuildingsRoadmapDTO } from 'csr-asset-app';
import { ReportPage } from '../report-page';
import {
  ReportRoadmapBuildingPage,
  ReportRoadmapBuildingTrailingContentContext
} from '../report-roadmap-building-page';

@Component({
  selector: 'cfp-report-appendices-pages',
  templateUrl: 'report-appendices-pages.html',
  imports: [ReportPage, ReportRoadmapBuildingPage, TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReportAppendicesPages {
  public readonly customerName = input.required<string>();
  public readonly buildings = input.required<PortfolioBuildingsRoadmapBuildingDTO[]>();
  public readonly portfolioBuildingsRoadmap = input.required<PortfolioBuildingsRoadmapDTO>();
  public readonly buildingExtraPage = input<TemplateRef<ReportRoadmapBuildingTrailingContentContext> | undefined>(
    undefined
  );
  /** Reserved height for buildingExtraPage when embedded below tables (0 = always separate page). */
  public readonly buildingExtraPageHeight = input(0);
  /** When true, the last building’s last sheet is the end of the report (suppresses trailing blank page). */
  public readonly endsReport = input(false);
  public readonly translationKeyPrefix = input('portfolioBuildingsRoadmapReport');
  public readonly showEnergyLabelHistory = input(true);
  public readonly headerLogo = input<string | undefined>(undefined);
  public readonly chromeFooter = input<TemplateRef<unknown> | undefined>(undefined);

  protected translationKey(suffix: string): string {
    // Content keys always use the shared namespace (LBG overrides via custom i18n).
    // translationKeyPrefix is only for report-page chrome title (buildings vs RETLL).
    return `portfolioBuildingsRoadmapReport.${suffix}`;
  }
}
